import { CCStatus, PortStatus } from "../../../enums";
import { PortColor } from "../../../utils/appConstants";
import PortImage from "../../ResourceImages/Port";

const StatusButton: React.FC<{ verified: boolean; portStatus: string; ccStatus: string }> = ({ verified, portStatus, ccStatus }) => {
  const size = 32;
  if (portStatus === PortStatus.sold) {
    return <PortImage color={PortColor.Red} plugColor={PortColor.Red} size={size} />;
  } else if (portStatus === PortStatus.listed) {
    return <PortImage color={PortColor.Yellow} plugColor={PortColor.LightYellow} size={size} />;
  }
  let color = PortColor.Grey;
  if (verified) {
    color = PortColor.Green;
  }
  let plug = PortColor.Grey;
  if (ccStatus === CCStatus.green) {
  } else if (ccStatus === CCStatus.none) {
    if (color === PortColor.Green) plug = PortColor.LightGreen;
    else plug = PortColor.LightGrey;
  }
  return <PortImage color={color} plugColor={plug} size={size} />;
};
export default StatusButton;
